import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const loadFunction = async () => {
  initResizeHandler();

  const swiper = new Swiper(".swiper", {
    // Optional parameters
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 20,
    // slidesOffsetBefore: 20, // ← 左パディング
    // slidesOffsetAfter: 20, // ← 右パディング
    direction: "horizontal",
    loop: false,

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    pagination: {
      el: ".swiper-dots",
      clickable: true, // ← ドットをクリック可能に
    },
  });

  // const links = document.querySelectorAll('a[href^="/#"]');
  const links = document.querySelectorAll('a[href*="#"]');
  // const HashLinks = document.querySelectorAll('a[href^="#"]');
  const offset = 80;
  const duration = 400;

  // ---------------------------------
  // ① アンカーリンククリック時
  // ---------------------------------
  links.forEach((link) => {
    link.addEventListener("click", (e) => {
      const hash = link.getAttribute("href"); // "#about"
      if (!hash) return;
      if (hash === "#") {
        e.preventDefault();
        smoothScroll(hash);
        return;
      }

      const target = document.querySelector(hash);

      // 同一ページにアンカーが存在する場合
      if (target) {
        e.preventDefault();
        smoothScroll(hash);
        return;
      }

      // アンカーが存在しない = 別ページ（TOP想定）
      e.preventDefault();
      console.log(location.pathname);
      const parentPath = getParentPath(location.pathname);
      window.location.href = parentPath + hash;
    });
  });

  function getParentPath(pathname) {
    const trimmed = pathname.replace(/\/$/, "");
    const parent = trimmed.substring(0, trimmed.lastIndexOf("/") + 1);

    return parent || "/";
  }

  // ---------------------------------
  // ② ページロード時に hash がある場合
  // ---------------------------------
  if (location.pathname === "/" && location.hash) {
    // ↑TOPページに hash 付きで遷移してきた場合
    const hash = location.hash;
    // 初期ジャンプの位置を少し戻す
    window.scrollTo(0, 0);
    // ちょっと遅延させてスムーススクロール発火
    setTimeout(function () {
      smoothScroll(hash);
    }, 10);
  }

  // ---------------------------------
  // 共通：スムーススクロール関数
  // ---------------------------------
  function smoothScroll(hash) {
    let targetPosition;

    if (hash === "#" || hash === "") {
      targetPosition = 0;
    } else {
      const target = document.querySelector(hash);
      if (!target) return;
      targetPosition =
        target.getBoundingClientRect().top + window.pageYOffset - offset;
    }
    const start = window.pageYOffset;
    const startTime = Date.now();

    (function scroll() {
      const now = Date.now();
      const time = Math.min(1, (now - startTime) / duration);
      const eased = 1 - Math.pow(1 - time, 3);

      window.scrollTo(0, eased * (targetPosition - start) + start);

      if (time < 1) requestAnimationFrame(scroll);
    })();
  }

  initInterimTab();
};

const resizeFunction = async () => {
  const header = document.querySelector("header");
  const main = document.querySelector("main");

  if (!header || !main) return;

  const headerHeight = header.offsetHeight;
  main.style.paddingTop = `${headerHeight}px`;
};

const initInterimTab = async () => {
  const radios = document.querySelectorAll('input[name="interim_tab"]');
  const list = document.querySelector(".interim_list");

  if (!radios.length || !list) return;

  // 現在つく可能性のあるクラス一覧（必要に応じて増やせる）
  const classList = ["gourmet", "takeout", "gift"];

  const updateListClass = (value) => {
    // 対象クラスのつけ直し
    list.classList.remove(...classList);
    list.classList.add(value);
  };

  // 初期状態を反映（checkedを拾う）
  const checked = document.querySelector('input[name="interim_tab"]:checked');
  if (checked) updateListClass(checked.value);

  // イベント設定
  radios.forEach((radio) => {
    radio.addEventListener("change", (e) => {
      updateListClass(e.target.value);
    });
  });
};

const initResizeHandler = () => {
  // 読み込み時
  resizeFunction();

  // リサイズ時
  window.addEventListener("resize", () => {
    resizeFunction();
  });
};

window.addEventListener('load', loadFunction);
// window.addEventListener("resize", resizeFunction);